/**
 * Created by 胡长伟 on 2020-03-07.
 */
import merchtApi from '../../api/retailer';
import custTagMeataApi from '../../api/objTagConf'

let query_meta_cache = {};
let result_meta_cache = {};
//
let mixed_meta_cache = {};

function getMetaQueryConf(key, callback) {
    let params = {code: key};
    merchtApi.getMetaQueryConf(params, function (result) {
        if (result.type == 'info') {
            callback(result.data);
            //
        } else {
            callback(null);
        }
    });
}

function getMetaResultConf(key, callback) {
    let params = {code: key};
    merchtApi.getMetaResultConf(params, function (result) {
        if (result.type == 'info') {
            callback(result.data);
            //
        } else {
            callback(null);
        }
    });
}

function getQryResultMetaConf(key, callback) {
    let params = {code: key};
    merchtApi.getQryResultMetaConf(params, function (result) {
        if (result.type == 'info') {
            callback(result.data);
            //
        } else {
            callback(null);
        }
    });
}

// 获取实体的实自定义标签的字段配置（兼容包括对象和业务标签）
function getCustTagMetaFields(metaRoleTableList, callback) {
    custTagMeataApi.getCustTagMetaFields(metaRoleTableList, function (result) {
        if (result.type == 'info') {
            callback(result.data);
            //
        } else {
            callback(null);
        }
    });
}

function getCustQueryConf(key, callback) {
    let params = {code: key};
    merchtApi.getCustQueryConf(params, function (result) {
        if (result.type == 'info') {
            callback(result.data);
            //
        } else {
            callback(null);
        }
    });
}

function getCustResultConf(key, callback) {
    let params = {code: key};
    merchtApi.getCustResultConf(params, function (result) {
        if (result.type == 'info') {
            callback(result.data);
            //
        } else {
            callback(null);
        }
    });
}

export function getIncludeSubComsByMetaQueryConf(key, callback) {
    getMetaQueryConf(key, function (data) {
        let includeSubComs = false;
        if (data != null) {
            let queryVars = data.queryVars;
            if (queryVars != null && queryVars != '') {
                let queryVarList = JSON.decode(queryVars);
                if (queryVarList != null && queryVarList.length > 0) {
                    let queryVarMap = queryVarList.toMap("name");
                    let item = queryVarMap["includeSubComs"];
                    if (item == null) {
                        includeSubComs = false;
                    } else {
                        if (item.value == "true") {
                            includeSubComs = true;
                        } else {
                            includeSubComs = false;
                        }
                    }
                }
            }
        }
        callback(includeSubComs);
    });
}

function QueryResultConfStorer() {
    //---------------------- 元设 配置 获取 -----------------------
    //仅仅获取查询配置
    this.loadMetaQueryConf = function (key, callback) {
        //from cache
        let metaConf = query_meta_cache[key];
        if (metaConf == null) {
            // metaConf = getMetaQueryConf(key);
            getMetaQueryConf(key, function (data) {
                metaConf = data;
                //
                if (metaConf != null) {//
                    query_meta_cache[key] = metaConf;
                }
                //
                let success = metaConf != null;
                if (typeof callback == 'function') {
                    callback(success, success ? metaConf : '未找到对应的元数据配置信息');
                } else {
                    success ? console.log(metaConf) : console.error('未找到对应的元数据配置信息');
                }
            });
        } else {
            //结果回调
            let success = metaConf != null;
            if (typeof callback == 'function') {
                callback(success, success ? metaConf : '未找到对应的元数据配置信息');
            } else {
                success ? console.log(metaConf) : console.error('未找到对应的元数据配置信息');
            }
        }
    };
    //仅仅获取结果配置
    this.loadMetaResultConf = function (key, callback) {
        //from cache
        let metaConf = result_meta_cache[key];
        if (metaConf == null) {
            // metaConf = getMetaResultConf(key);
            getMetaResultConf(key, function (data) {
                metaConf = data;
                //
                if (metaConf != null) {//put into cache
                    result_meta_cache[key] = metaConf;
                }
                //结果回调
                let success = metaConf != null;
                if (typeof callback == 'function') {
                    callback(success, success ? metaConf : '未找到对应的元数据配置信息');
                } else {
                    success ? console.log(metaConf) : console.error('未找到对应的元数据配置信息');
                }
            });
        } else {
            //结果回调
            let success = metaConf != null;
            if (typeof callback == 'function') {
                callback(success, success ? metaConf : '未找到对应的元数据配置信息');
            } else {
                success ? console.log(metaConf) : console.error('未找到对应的元数据配置信息');
            }
        }
    };

    //同时获取查询+结果配置(key为query的)
    this.loadMetaQueryResultConf = function (key, callback) {
        //from cache
        let mixedConf = mixed_meta_cache[key];
        if (mixedConf == null) {
            // mixedConf = getQryResultMetaConf(key);
            getQryResultMetaConf(key, function (data) {
                mixedConf = data;
                //
                if (mixedConf != null) {//put into cache
                    mixed_meta_cache[key] = mixedConf;
                }
                //
                let success = mixedConf != null;
                if (typeof callback == 'function') {
                    callback(success, success ? mixedConf : '未找到对应的元数据配置信息');
                } else {
                    success ? console.log(mixedConf) : console.error('未找到对应的元数据配置信息');
                }
            });
        } else {
            //
            let success = mixedConf != null;
            if (typeof callback == 'function') {
                callback(success, success ? mixedConf : '未找到对应的元数据配置信息');
            } else {
                success ? console.log(mixedConf) : console.error('未找到对应的元数据配置信息');
            }
        }
    };

    //---------------------- 自定义标签 配置 获取 -----------------------
    //metaRoleTableList : [{tagMetaRole, tagMetaTableName}]
    this.loadCustTagMetaFields = function (metaRoleTableList, callback) {
        //逻辑同 getCustTagMetaFields
        // let tagMetaFields = getCustTagMetaFields(metaRoleTableList) || [];
        getCustTagMetaFields(metaRoleTableList, function (data) {
            let tagMetaFields = data || [];
            if (typeof callback == 'function') {
                callback(true, tagMetaFields);
            } else {
                console.log(tagMetaFields);
            }
        });
    };

    //---------------------- 个性 配置 获取 -----------------------
    //注意后台要用上下文的staffId
    //加载个性查询配置
    this.loadCustQueryConf = function (key, callback) {
        //逻辑同 loadMetaQueryConf
        // let custConf = getCustQueryConf(key) || {};
        getCustQueryConf(key, function (data) {
            let custConf = data || {};
            if (typeof callback == 'function') {
                callback(true, custConf);
            } else {
                console.log(custConf);
            }
        });
    };
    //加载个性结果配置
    this.loadCustResultConf = function (key, callback) {
        //逻辑同 loadMetaQueryConf
        // let custConf = getCustResultConf(key) || {};
        getCustResultConf(key, function (data) {
            let custConf = data || {};
            if (typeof callback == 'function') {
                callback(true, custConf);
            } else {
                console.log(custConf);
            }
        });
    };
    //--------------------------------------------------
    //保存个性查询配置
    this.saveCustQueryConf = function (key, custConf, callback) {
        console.log('保存自定义查询排序配置信息：' + key);
        // console.log(custConf);
        //console.log(JSON.encode(custConf));
        let postData = {
            metaCode: key,
            queryFields: custConf.queryFields || null,
            sortFields: custConf.sortFields || null
        };
        merchtApi.saveCustQueryConf(postData, function (result) {
            let success = result.type == 'info';
            if (typeof callback == 'function') {
                callback(success, result.message);
            } else {
                console.log(result);
            }
        });
    };
    //保存个性结果配置
    this.saveCustResultConf = function (key, custConf, callback) {
        console.log('保存自定义结果配置信息：' + key);
        // console.log(custConf);
        //console.log(JSON.encode(custConf));
        let postData = {
            metaCode: key,
            colList: custConf.colList || null,
        };
        merchtApi.saveCustResultConf(postData, function (result) {
            let success = result.type == 'info';
            if (typeof callback == 'function') {
                callback(success, result.message);
            } else {
                console.log(result);
            }
        });
    };
}

//
let queryResultConfStorer = new QueryResultConfStorer();

export default queryResultConfStorer;



//////////////////
// WEBPACK FOOTER
// ./src/compo/conf/ComnConfStorer.js
// module id = 52
// module chunks = 0